export function getChatUrlPath(chatId: string): string {
  return `/chats/${chatId}`;
}
